import * as v from "valibot";
import { defineRecordSchema, defineValidation } from "../../common/validation.common";

export namespace SkipAuditSubscriptionValidation {
    export const Record = defineValidation(
        defineRecordSchema({
            filters: v.object({
                skipAudit: v.optional(v.boolean()),
                associateId: v.optional(v.string()),
            }),
        }),
    );
}
